import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { QuestionlistComponent } from './questionlist/questionlist.component';
import { LoginComponent } from './login/login.component';
import { MeetingPickerComponent } from './meeting-picker/meeting-picker.component';
import { WatchMeetingComponent } from './watch-meeting/watch-meeting.component';
import { AuthGuard } from './shared/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'meetings',
    component: MeetingPickerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'watch/:scoId',
    component: WatchMeetingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'list',
    component: QuestionlistComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: "login",
    pathMatch: "full"
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {






}
